import { render, staticRenderFns } from "./KitchenProductSummary.vue?vue&type=template&id=06b83674&scoped=true"
import script from "./KitchenProductSummary.vue?vue&type=script&lang=js"
export * from "./KitchenProductSummary.vue?vue&type=script&lang=js"
import style0 from "./KitchenProductSummary.vue?vue&type=style&index=0&id=06b83674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b83674",
  null
  
)

export default component.exports